import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useReceivableModel } from "../receivablesModel";
import { IReceivableDetail } from "../receivablesService";
import { formatNum, momentFormat } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTootip from "@/components/YhTootip";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useReceivableModel();
    const { getTreeNodeName } = useDictModel();

    useEffect(() => {
        loadData();
    }, [])

    const columns: ColumnsType<IReceivableDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '单据编号',
            width: 180,
            dataIndex: 'documentNumber',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单据类型',
            width: 180,
            dataIndex: 'tradeTypeCode',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '客户名称',
            width: 180,
            dataIndex: 'companyName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '应收账款',
            width: 120,
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '工时费',
            width: 120,
            dataIndex: 'workingHoursAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '材料费',
            width: 120,
            dataIndex: 'materialScienceAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '优惠金额',
            width: 120,
            dataIndex: 'discountTotalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '结算方式',
            width: 120,
            dataIndex: 'payType',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '制单员',
            width: 120,
            dataIndex: 'createUser',
        }, {
            title: '制单日期',
            width: 150,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '单据备注',
            width: 150,
            dataIndex: 'note',
        }, {
            title: '欠款时长',
            width: 120,
            dataIndex: '',
            fixed: "right"
        }
    ];

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            loading={loading}
            rowKey={record => record.id}
            // rowSelection={{
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.id);
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.id),
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id)
            // })}
            scroll={{ x: 'max-content', y: "calc(100vh - 410px)" }}
        />
    )
}